import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query'
import { getErrorReporter } from './error-reporter.js'
import { getErrorStatus } from './wretch-errors.js'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5_000,
      refetchOnWindowFocus: true,
      retry: 1,
    },
  },
  queryCache: new QueryCache({
    onError: (error, query) => {
      if (query?.meta?.onError) {
        ;(query.meta.onError as (err: Error) => void)(error)
      }
    },
  }),
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) => {
      getErrorReporter()(error, {
        source: 'mutation',
        key: mutation?.options.mutationKey,
        status: getErrorStatus(error),
      })
      if (mutation?.meta?.onError) {
        ;(mutation.meta.onError as (err: Error) => void)(error)
      }
    },
  }),
})
